(() => {
  if (customElements.get('sticky-button-bar')) return;

  class StickyButtonBar extends HTMLElement {
    constructor() {
      super();
      this.onScroll = this.onScroll.bind(this);
    }

    connectedCallback() {
      this.scrollThreshold = Number(this.dataset.scrollThreshold) || 0;
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      document.body.classList.remove('has-sticky-button-bar');
    }

    onScroll() {
      const isVisible = window.scrollY > this.scrollThreshold;
      this.classList.toggle('is-visible', isVisible);
      document.body.classList.toggle('has-sticky-button-bar', isVisible);
    }
  }

  customElements.define('sticky-button-bar', StickyButtonBar);
})();
